import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import api from '../../services/api';
import { TextField, FormGroup, Container } from '@mui/material';
import * as Yup from 'yup';
import Progress from '../../components/Progress';
import HandleParametes from './handleParameters';
import { useDispatch, useSelector } from 'react-redux';
import { setDisable } from '../../redux/disable';
import { useStyles } from '../../components/Styles';
import DialogMain from '../../components/Dialogs/dialogMain';
import Success from '../../components/Snack/Success';
import Error from '../../components/Snack/Error';
import GroupButton from '../../components/Buttons/ButtonGroup';

function Protocol() {
  const location = useLocation();
  const [parameters, setParameters] = useState([]);
  const [initialParameters, setInitialParameters] = useState([]);
  const [openParameter, setOpenParameter] = useState(false);
  const [openProgress, setOpenProgress] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  let { id } = useParams();
  const classes = useStyles();
  const disable = useSelector((state) => state.disable.disable);
  const error = Error();
  const success = Success();

  function newOptions(options) {
    formik.setFieldValue('rules', options);
  }

  const formik = useFormik({
    // Criação dos campos e validação para o formulário
    initialValues: {
      name: '',
      newParameterId: '',
      newTolerance: '',
      disabledAdd: true,
      rules: [],
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Campo Obrigatório'),
      rules: Yup.array().required('Campo Obrigatório'),
    }),
    onSubmit: (values) => {
      request(values);
    },
  });

  useEffect(() => {
    if (location.state !== undefined) {
      if (location.state.customData) {
        setData(location.state.customData);
      } else if (location.state.data) {
        setData(location.state.data);
      }
    }
  }, [location]);

  function setData(data) {
    id = location.state.id;
    formik.setValues(data);

    formik.setValues({
      ...data,
      rules: data.rules.map((rule) => ({
        protocol_id: id,
        parameter_id: rule.parameter.id,
        tolerance: rule.tolerance,
        parameter_name: rule.parameter.name,
      })),
    });
  }

  useEffect(() => {
    async function load() {
      // carrega os dados no seu devido campo caso tenha id, do contrário,
      // carrega o formulário vazio para cadastrar um novo
      setOpenProgress(true);

      const parameter_ = await api.get('/parameters');

      if (parameter_.data.length === 0) {
        setOpenParameter(true);
      }

      const ambientParameter = [];

      parameter_.data.map((item) => {
        // if (item.type === "Água" && item.hasOptions === false)
        if (!item.hasOptions) ambientParameter.push(item);
        return null;
      });

      setParameters(ambientParameter);

      function changeNewParameters(parameters) {
        formik.setFieldValue('parameters', parameters);
        setInitialParameters(
          formik.values.rules.map((v) => ({ parameter_id: v.parameter_id })),
        );
      }

      changeNewParameters(ambientParameter);
      setOpenProgress(false);
    }
    load();
  }, []);

  async function request(data) {
    // envia os dados para api salvar no banco de dados.
    dispatch(setDisable(true));

    /// if()
    try {
      if (id) {
        const results = initialParameters.filter(
          ({ parameter_id: id1 }) => !formik.values.rules.some(({ parameter_id: id2 }) => id2 === id1),
        );

        results.forEach(async (value, i) => {
          await api.delete(`/protocols/${id}/rules/${value.parameter_id}`);
        });
        await api.put(`/protocols/${id}`, { ...data });
      } else {
        await api.post('/protocols', { ...data });
      }
      success();
      history.push('/protocols');
    } catch (err) {
      error();
    }
    dispatch(setDisable(false));
  }

  return (
    <Container>
      {openProgress ? <Progress /> : null}
      {' '}
      {/** Carregamento circular para o carregamento dos dados */}
      <form onSubmit={formik.handleSubmit}>
        <form className={classes.root}>
          <h2 className="title"> Dados do Protocolo de Transferência </h2>

          {/** *
           *  Diálogos para facilitar cadastro.
           */}

          {openParameter ? (
            <DialogMain
              message="A propridade não possui nenhum parâmetro cadastrado. Por favor, cadastre um parâmetro para prosseguir."
              route="/parameter"
            />
          ) : null}
          <FormGroup>
            <TextField
              InputLabelProps={{ style: { pointerEvents: 'auto' } }}
              id="name"
              label={<div>Nome do Protocolo</div>}
              variant="outlined"
              request="true"
              name="name"
              type="text"
              style={{ marginLeft: 16 }}
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={!!(formik.touched.name && formik.errors.name)}
              helperText={
                formik.touched.name && formik.errors.name && formik.errors.name
              }
            />
          </FormGroup>

          {/** Componente que organiza os parâmetros do protocolo */}

          <FormGroup>
            <HandleParametes
              disabledAdd={formik.values.disabledAdd}
              protocol_id={id}
              options={formik.values.rules}
              newParameterId={formik.values.newParameterId}
              onChange={formik.handleChange}
              parameters={parameters}
              callback={newOptions}
            />
          </FormGroup>
        </form>

        <GroupButton
          deleteRoute="/protocols/"
          routeDelete="/protocols"
          returnRoute="/protocols"
          id={id}
          disable={disable}
          message="A exclusão desse protolo pode levar a exclusão de objetos que dependam dele. Tem certeza que deseja excluir?"
        />
      </form>
    </Container>
  );
}

export default Protocol;
